<mat-card>
  <mat-card-title>
    {{ '+INVITATIONS.INVITATIONS.INVITATION.ACCEPT_DIALOG.TITLE' | translate }}
  </mat-card-title>
  <mat-card-content>
    <div
      [innerHTML]="
        '+INVITATIONS.INVITATIONS.INVITATION.ACCEPT_DIALOG.MESSAGE' | translate | trustHtml
      "
    ></div>
  </mat-card-content>
  <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
    <button
      id="cancel-btn"
      mat-stroked-button
      color="primary"
      gtm="onClose"
      gtmCategory="acceptInvitation"
      (click)="onClose()"
    >
      {{ 'GENERAL.BUTTON.DO_IT_LATER' | translate }}
    </button>
    <button
      id="next-btn"
      mat-raised-button
      color="primary"
      gtm="acceptInvitation"
      (click)="onAccept()"
    >
      {{ 'GENERAL.BUTTON.ACCEPT' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
